import { render, staticRenderFns } from "./VipCourseItem.vue?vue&type=template&id=a82d1f6e&lang=html"
import script from "./VipCourseItem.vue?vue&type=script&lang=js"
export * from "./VipCourseItem.vue?vue&type=script&lang=js"
import style0 from "./VipCourseItem.vue?vue&type=style&index=0&id=a82d1f6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports